import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthJwtInterceptorService } from './services/auth-jwt-interceptor.service';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(NgbModalModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideToastr(),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthJwtInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'es' }
  ]
};
